<template>
  <div class="table-list__item">
    <a
      v-if="item.url"
      :href="item.url"
      target="_blank"
      rel="noopener">
      <p
        v-if="item.year"
        class="year">
        {{ item.year }}
      </p>
      <p
        v-if="item.title"
        class="title">
        {{ item.title }}
      </p>
      <p
        v-if="item.association"
        class="assoc">
        {{ item.association }}
      </p>
      <p
        v-if="item.publication"
        class="pub">
        {{ item.publication }}
      </p>
    </a>
    <div v-else>
      <p
        v-if="item.year"
        class="year">
        {{ item.year }}
      </p>
      <p
        v-if="item.title"
        class="title">
        {{ item.title }}
      </p>
      <p
        v-if="item.association"
        class="assoc">
        {{ item.association }}
      </p>
      <p
        v-if="item.publication"
        class="pub">
        {{ item.publication }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableItem',
  props: {
    item: {
      type: Object,
      default: null
    },
  }
}
</script>

<style lang="scss" scoped>
.table-list__item {
  > a,
  > div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    font-weight: bold;

    @include mobile {
      flex-direction: column;
      margin-bottom: $gutter--base;
    }
  }

  a {
    color: $color--white;
  }

  p {
    padding-right: $padding--base;
  }

  .year {
    width: 10%;
  }
  .title {
    width: 40%;
  }
  .assoc,
  .pub {
    width: 50%;
  }

  @include mobile {
    .year,
    .title,
    .assoc,
    .pub {
      width: 100%;
    }
  }
}
</style>
